import { Box, Button, Typography } from '@mui/material';
import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TournamentTable from '../ui/table/tournamentTable';

const Tournaments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tournaments = useSelector((state) => state.tournament.tournaments);
  const loading = useSelector((state) => state.tournament.loading);

  return (
    <Fragment>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={2}>
        <Typography variant="h4">Tournaments</Typography>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Button
            variant="outlined"
            onClick={() => navigate('/tournaments/archive')}
            sx={{ ml: 2 }}>
            View Archive
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate('/tournaments/create')}
            sx={{ ml: 2 }}>
            Create Tournament
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate('/tournaments/import')}
            sx={{ ml: 2 }}>
            Import Tournament
          </Button>
        </Box>
      </Box>
      <TournamentTable
        tournaments={tournaments}
        onEdit={(t) => console.log('edit')}
        onDelete={(t) => console.log('delete')}
      />
    </Fragment>
  );
};

export default Tournaments;
